'use client';
import { CUSTOMER_LEVEL } from "@prisma/client";
import { ProductHighlight } from '@/util/query/product-highlight-query';
import { MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import ProductHighlightCarousel from './product-highlight-carousel';
import { borderRadiusShorthand, useLayoutStyle } from "@/lib/providers/layout-style-provider";
import ArrowButtonSvg from '@/assets/icons/arrow-button.svg?react';

type ProductHighlightType2Props = {
    data: ProductHighlight;
    productList: MSProductWithFullDetailWithVaraintPreset[];
    level: CUSTOMER_LEVEL;
    shopCurrency: string;
    /** Number of SOLID cards shown per row on mobile. Defaults to 2. */
    mobileColumn?: number;
}

const ProductHighlightType2 = (props: ProductHighlightType2Props) => {
    const { data, productList, level, shopCurrency, mobileColumn } = props;
    const layoutStyle = useLayoutStyle();

    return ((data.attributes && (data.attributes.title || data.attributes.description || data.attributes.buttonDisplayName)) || (productList.length > 0)) && (
        <div id={`product-highlight-component-type2-container-${data.id}`} className={mobileColumn === 3 ? 'w-full py-[24px] px-[18px] sm:px-[120px]' : 'w-full py-[40px] px-[30px] sm:px-[120px]'} style={{ background: "linear-gradient(180deg, #FFC20E 0%, #FFFFFF 100%)" }}>
            <div id="product-highlight-component-type2-content" className={`w-full flex flex-col justify-center items-center ${mobileColumn === 3 ? 'gap-6' : 'gap-10'}`}>
                {(data.attributes && (data.attributes.title || data.attributes.description)) && (
                <div id="product-highlight-component-type2-title-container" className="w-full flex flex-col items-center text-center">
                    {data.attributes.title && 
                        <h2 
                            id="product-highlight-component-type2-title" 
                            className={`font-medium ${mobileColumn === 3 ? 'lg:text-[4rem] sm:text-[3rem] text-[1.5rem]' : 'lg:text-[4rem] text-[3rem]'}`}
                            style={{ color: "#54301A"}}
                        >
                            {data.attributes.title}
                        </h2>
                    }
                    {data.attributes.description && 
                        <p
                            id="product-highlight-component-type2-description" 
                            className="text-base font-normal"
                            style={{ color: "#54301A"}}
                        >
                            {data.attributes.description}
                        </p>
                    }
                </div>)}
                { (productList.length > 0) && (
                <ProductHighlightCarousel 
                    productList={productList} 
                    level={level} 
                    shopCurrency={shopCurrency}
                    type="TYPE_2"
                    mobileColumn={mobileColumn}
                />)}
                
                {(data.attributes && data.attributes.buttonDisplayName) && (
                <div id="product-highlight-component-type2-button-container" className="w-full flex justify-center items-center">
                    <a id="product-highlight-component-type2-button-link" href={data.attributes.buttonLinkUrl || ""} aria-label="button">
                        <button 
                            id="product-highlight-component-type2-button" 
                            className={`w-fit h-fit py-[8px] font-medium border-solid border-2 dynamic-bg dynamic-color dynamic-border ${mobileColumn === 3 ? 'min-w-[120px] min-h-[38px] sm:min-w-[221px] sm:min-h-[60px] pl-[20px] pr-[4px] sm:pl-[40px] sm:pr-[8px]' : 'min-w-[221px] min-h-[60px] pl-[40px] pr-[8px]'}`}
                            aria-label="Link Button"
                            style={
                                {
                                    "--dynamic-bg": "#FFC20E",
                                    "--dynamic-hover-bg": "#FFF200",
                                    "--dynamic-color": "#54301A",
                                    "--dynamic-hover-color": "#54301A",
                                    "--dynamic-focus-color": "#54301A",
                                    "--dynamic-hover-focus-color": "#54301A",
                                    "--dynamic-border": "#FFFFFF",
                                    "--dynamic-hover-border": "#FFFFFF",
                                    borderRadius: borderRadiusShorthand(layoutStyle)
                                } as React.CSSProperties
                            }>
                            <div id="product-highlight-component-type2-button-content" className={`flex flex-row gap-2 items-center justify-between whitespace-nowrap ${mobileColumn === 3 ? 'text-[10px] sm:text-base' : ''}`}>
                                {data.attributes.buttonDisplayName}
                                <ArrowButtonSvg id="product-highlight-component-type2-button-arrow" className={mobileColumn === 3 ? 'h-6 w-6 sm:w-10 sm:h-10' : 'h-10 w-10'}/>
                            </div>
                        </button>
                    </a>
                </div>)}
            </div>
        </div>
    )
}

export default ProductHighlightType2